// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import styles from './category_page.module.less';
import {Articles_section} from './articles_section';
import {Splash_screen_loader} from '../../../../toolip/pub/ui/splash_screen_loader/splash_screen_loader';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
import {get_data_id} from '../../pages/oculus.toolip.io/blog';
import {fetch_articles_for_cards} from './more_articles';
import etask from 'zetask';

interface i_article_data {
    url: string;
    category?: string | string[];
    title?: string;
    description?: string;
    img?: string;
    author?: string;
    min_read?: number;
}

export const Category_page = ()=>{
    const {category} = useParams<{category: string}>();
    const {data} = use_data_provider(get_data_id);
    const [articles, set_articles] = useState<i_article_data[]>([]);
    const [loading, set_loading] = useState(true);
    const display_category = category ?
        category.split('-')
            .map(word=>word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ') : '';
    useEffect(()=>{
        console.log('Data:', data);
        if (data?.status == 'done')
        {
            set_articles(data.result?.data?.posts || []);
            set_loading(false);
        }
        else
            set_loading(true);
    }, [data]);
    useEffect(()=>{
        etask(function*(){
            const fetched_articles = yield fetch_articles_for_cards();
            set_articles(fetched_articles || []);
            set_loading(false);
        });
    }, []);
    if (loading)
        return <Splash_screen_loader show={true}/>;
    return <div className={styles.categories_container}>
      <Articles_section
        articles={articles}
        initial_category={display_category}
        title={display_category}
      />
    </div>;
};
